import highFiveUrl from '../../assets/gesture/high_five.png';
import goodLuckUrl from '../../assets/gesture/good_luck.png';
import cheersUrl from '../../assets/gesture/cheers.png';

/**
 * v1 social-gesture set — 2026-06-08 producer pivot. Replaced the
 * ambient emoji reactions (cheer/heart/fire/laugh, which read as bot
 * spam) with three intentional, value-add gestures in the Peloton
 * high-five spirit: a gesture is a directed (one-to-one) or to-the-
 * table social beat, not a passive reaction-emoji.
 *
 * <p>Ids mirror the server's {@code VALID_REACTION_IDS} (WheelGameRules);
 * the art lives in {@code apps/mobile/src/assets/gesture/<id>.png},
 * commissioned via the goodtime-server toolgen {@code gestureAsset}
 * family. A directed gesture surfaces in the {@code GestureToast} for
 * its recipient; an untargeted one floats over the sender's avatar
 * ({@code ReactionFloat}).
 */
export interface GestureDef {
  /** Server reaction id (sent as the REACTION command's reactionId arg). */
  id: string;
  /** Tray button + send-menu label. */
  label: string;
  /** Completes "{senderName} {toast}" in the recipient's toast —
   *  e.g. "Ruby high-fived you". */
  toast: string;
  /** Commissioned sprite url (assets/gesture/<id>.png). */
  src: string;
}

export const GESTURES: readonly GestureDef[] = [
  { id: 'high_five', label: 'High five', toast: 'high-fived you', src: highFiveUrl },
  { id: 'good_luck', label: 'Good luck', toast: 'wished you good luck', src: goodLuckUrl },
  { id: 'cheers', label: 'Cheers', toast: 'raised a glass to you', src: cheersUrl },
];

export const GESTURE_BY_ID: Readonly<Record<string, GestureDef>> = Object.fromEntries(
  GESTURES.map((g) => [g.id, g]),
);

/** Gesture sent by the toast's "High five back" reciprocate action. */
export const RECIPROCATE_GESTURE_ID = 'high_five';
